import {FC, ReactNode} from 'react';

import {ChevronDownIcon} from '@heroicons/react/solid';
import {ChevronUpIcon} from '@heroicons/react/solid';
import {Disclosure} from '@headlessui/react';
import {Heading} from '~/modules/Common/components/Heading';
import {ReadMore} from './ReadMore';

interface PanelProps {
  headline: string | ReactNode;
  copy: string;
  isOpen: boolean;
  shouldTruncate?: boolean;
}

export const Panel: FC<PanelProps> = ({
  headline,
  isOpen,
  copy,
  shouldTruncate = false,
}) => {
  return (
    <Disclosure as="div" className="w-full" defaultOpen={isOpen}>
      {({open}) => (
        <>
          <Disclosure.Button className="flex justify-between items-center gap-2 w-full py-4 text-expertPrimary border-solid border-codGray50 border-b-[1px] ">
            <Heading
              as="h3"
              size="bodyMd"
              className="font-bold text-medium capitalize text-left"
            >
              {typeof headline === 'object' ? (
                headline
              ) : (
                <span dangerouslySetInnerHTML={{__html: headline}} />
              )}
            </Heading>
            {open ? (
              <ChevronUpIcon width={20} />
            ) : (
              <ChevronDownIcon width={20} />
            )}
          </Disclosure.Button>
          <Disclosure.Panel>
            <ReadMore copy={copy} shouldTruncate={shouldTruncate} />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};
